module.exports = __webpack_public_path__ + "assets/img/bd91-gp.svg";